<template>
  <div id="layouts">
    <section id="header">
      <div class="header-logo">
        <img class="logo" :src="logo" alt="logo" />
      </div>
      <HeaderMenu />
      <HeaderToolbar />
    </section>
    <section id="container">
      <Menu />
      <section id="main">
        <router-view />
      </section>
    </section>
    <Setting />
  </div>
</template>

<script>
import HeaderMenu from '@/views/layouts/HeaderMenu.vue'
import HeaderToolbar from '@/views/layouts/HeaderToobar/index.vue'
import Menu from '@/views/layouts/Menu.vue'
import Setting from '@/views/layouts/Setting.vue'
import { message } from '@/utils/message'
import { mapState } from 'vuex'

export default {
  name: 'App',
  mixins: [message],
  components: {
    HeaderMenu,
    HeaderToolbar,
    Menu,
    Setting
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('sys', ['logo'])
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/config.scss';

#layouts {
  width: 100%;
  height: 100%;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
}
:deep(#header) {
  flex-shrink: 0;
  height: $header-height;
}
#header {
  font-size: 30px;
  background-color: #3366e8;
  display: flex;
  align-items: center;
  .header-logo {
    flex-shrink: 0;
    padding: 0 52px 0 22px;
    min-width: $menu-width;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .logo {
    max-height: 40px;
  }
  :deep(#headerMenu) {
    flex: 1 1;
    margin-right: 22px;
    min-width: 0;
  }
  :deep(#HeaderToolbar) {
    flex-shrink: 0;
  }
}
#container {
  flex: 1 1;
  display: flex;
  background-color: #f5f5fa;
}
:deep(#menu) {
  flex: 0 0 $menu-width;
  height: 100%;
}
#main {
  flex: 1 1;
  padding: 22px 24px;
  height: 100%;
  min-width: 0;
}
</style>
